import { postReq, putReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { AdvanceShareStyle, AdvanceShareStylePaginationFilterRequest, AdvanceShareStyleStatusEnum, UpsertAdvanceShareStyle } from '@/models/advance-share-style.model';
import { PaginationFilterRequest, PagedResponseModel, BaseResponseModel, PaginatedSelectModel } from "@/models/core.model";

export const getPagedAdvanceShareStyles = async (input: AdvanceShareStylePaginationFilterRequest): Promise<PagedResponseModel<AdvanceShareStyle>> => {
  return await getReq(createUrl("a/AdvanceShare/Style/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getAdvanceShareStylesLookup = async (input?: string, page?: number): Promise<PaginatedSelectModel> => {
  const model: PaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    isAscending: false
  };
  return await getPagedAdvanceShareStyles(model).then(data => 
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: itm.name
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })      
  );
};

export const getAdvanceShareStyle = async (id: number): Promise<BaseResponseModel<AdvanceShareStyle>> => {
  return await getReq(createUrl(`a/AdvanceShare/Style/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertAdvanceShareStyle = async (input: UpsertAdvanceShareStyle): Promise<BaseResponseModel<AdvanceShareStyle>> => {
  return await postReq(createUrl("a/AdvanceShare/Style/Upsert"),
    input
  ).then((res: any) => res.data);
};

export const updateAdvanceShareStyleStatus = async (id: number, status: AdvanceShareStyleStatusEnum): Promise<BaseResponseModel<null>> => {
  return await putReq(createUrl("a/AdvanceShare/Style/UpdateStatus"),
    {id, status}
  ).then((res: any) => res.data);
};
